import { AccessTimeOutlined, CheckCircleOutlined, HelpOutlineOutlined } from '@mui/icons-material';
import { ListItemIcon, SvgIconTypeMap } from '@mui/material';
import { TimelineListItem, TimelineListItemText } from '@procureai/ui-mui';
import { ElementType } from 'react';
import { useTranslation } from 'react-i18next';

import {
  TsrctFlowStepStatus,
  TsrctSourcingCaseFlowStep,
  TsrctSourcingCaseFlowStepStatus,
} from '@/generated/gql/graphql';

type FlowStepItemProps = {
  item: TsrctSourcingCaseFlowStep;
};
const ICON_MAP: Record<
  TsrctSourcingCaseFlowStepStatus,
  { icon: ElementType; color: SvgIconTypeMap['props']['color'] }
> = {
  [TsrctFlowStepStatus.COMPLETED]: { icon: CheckCircleOutlined, color: 'success' },
  [TsrctFlowStepStatus.NONE]: { icon: HelpOutlineOutlined, color: 'info' },
  [TsrctFlowStepStatus.PENDING]: { icon: AccessTimeOutlined, color: 'info' },
  [TsrctFlowStepStatus.PROCEED]: { icon: AccessTimeOutlined, color: 'info' },
};

export const FlowStepItem = ({ item }: FlowStepItemProps) => {
  const { t } = useTranslation('common');
  const { icon: StatusIcon, color: statusColor } = ICON_MAP[item.status] ?? ICON_MAP[TsrctFlowStepStatus.NONE];
  return (
    <TimelineListItem key={item.id}>
      <ListItemIcon>
        <StatusIcon color={statusColor} />
      </ListItemIcon>
      <TimelineListItemText
        primary={t(`FlowStepVariant.${item.variant}.title`)}
        secondary={t(`FlowStepVariant.${item.variant}.${item.status}.description`)}
      />
    </TimelineListItem>
  );
};
